export default {
  title: 'Productos',
  buttons: {
    add_product: 'Añadir producto',
  },
  modals: {
    delete_product: {
      title: '¿Estás seguro?',
      description:
        'Todas las suscripciones actuales con este producto seguirán activas, pero no se podrán crear más con él. ¡Esta acción no se puede deshacer!',
    },
    delete_price: {
      title: '¿Estás seguro?',
      description:
        'Todas las suscripciones actuales con este precio seguirán activas, pero no se podrán crear más con él. ¡Esta acción no se puede deshacer!',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_delete_product: 'Error al eliminar el producto',
    product_got_deleted: 'Producto eliminado',
    failed_to_delete_price: 'Error al eliminar el precio',
    price_got_deleted: 'Precio eliminado',
  },
};
